import * as React from "react";
import * as ReactDOM from "react-dom";
import StartPage from "./components/StartPage";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import 'promise-polyfill/src/polyfill';
import 'core-js/es/typed-array/uint32-array';
import 'core-js/es/array/find';
import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import Amplify from '@aws-amplify/core';
import i18nload from './i18n';

const theme = createMuiTheme({
    palette: {
      primary: {
        light: '#E53037',
        main: '#EF3340', //PANTONE 032 C
        dark: '#0D5487',
        contrastText: '#fff',
      },
      secondary: {
        light: '#FF0000', 
        main: '#FFD700', //PANTONE 012C
        dark: '#DDD700',
        contrastText: '#000',
      }
      ,
      type: "light"
    }
  })

Amplify.configure({
    Auth: {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'eu-west-1:a791597d-804f-42fc-8dea-1a74e2840496',
        
        // REQUIRED - Amazon Cognito Region
        region: 'eu-west-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'eu-west-1_bYre5iRIJ',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '4rskk0lr1ciu282bpsqksjqipk'
    }
});



i18nload.then(() => {
  ReactDOM.render(
      <MuiThemeProvider theme={theme}>
      <StartPage/>
      </MuiThemeProvider>,document.getElementById("main")
  );
});